import React, { useMemo } from 'react';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import ImportIcon from '@material-ui/icons/VerticalAlignBottom';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import {  useQueryWithStore } from 'react-admin';
import jwt_decode from 'jwt-decode'
import FolderIcon from '@material-ui/icons/Folder';
import CardIcon from './CardIcon';
import { green, blue } from '@material-ui/core/colors';
import ErrorBoundary from '../ErrorBoundary';

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
      },
      
    green: {
        color: '#fff',
        backgroundColor: green[500],
      },
    main: {
        flex: '1',
        marginLeft: '1em',
        marginTop: 20,
    },
    card: {
        padding: '16px 0',
        overflow: 'inherit',
        textAlign: 'left',
    },
    title: {
        padding: '0 16px',
        fontWeight: 'bold',

        fontSize: '24px'
    },
    value: {
        padding: '0 16px',
        minHeight: 48,
    },
  }));

const popup=(id)=>{
    alert(id);
}

const Import = () => {
    const classes = useStyles();
   
    let loc = ((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).location : ''   
    let brcode = ((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).branch_code : ''  
    const { loaded, data: files } = useQueryWithStore({
        type: 'getList',
        resource: 'labfilenames',
        payload: {
            filter: {
                option: 'import',
                location: loc,
                branch_code: brcode
            },
            sort: { field: 'name', order: 'DESC' },
            pagination: { page: 1, perPage: 100 },
        },
    });

    if (!loaded) return null;
    //console.log(files)

    const nb = files ? files.reduce(nb => ++nb, 0) : 0;
    return (
        <ErrorBoundary>  
        <div className={classes.main}>
            <CardIcon Icon={ImportIcon} bgColor="#4caf50" />
            <Card className={classes.card}>
                <Typography className={classes.title} color="textSecondary">
                    Import Files
                </Typography>
                <Divider />
                <List>
                    {files
                        ? files.map(record => (
                        <ListItem
                            button
                            to={{
                                pathname: `/fileview/create`,
                                name: `${record.filename}`,
                                option: 'import',
                                brcode:  `${brcode}`
                                }}
                                component={Link}
                                key={record.filename}
                        >                                
                            <ListItemAvatar>
                                <Avatar  className={classes.green} ><FolderIcon  /></Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={`${((record.filename).toUpperCase()).replace('_RESULTS','').replace('_JAV','')}`}
                            />
                        </ListItem>
                          ))
                        : null}
                </List>
            </Card>
        </div>
        </ErrorBoundary>  
    );
};

export default Import;